var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 144,
    viewBox: "0 0 160 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3276",
    "data-name": "Group 3276",
    transform: "translate(744.889 219.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5104",
    "data-name": "Path 5104",
    d: "M-584.889-88.494c-.377.135-.313.493-.393.773A15.908,15.908,0,0,1-601.2-75.835q-33.588.021-67.177,0-30.465,0-60.93-.006c-9.189-.011-15.976-6.956-15.565-15.865a16.763,16.763,0,0,1,2.449-7.562q22.53-39.524,45.037-79.063c6.357-11.16,12.8-22.275,19.038-33.5a15.4,15.4,0,0,1,22.018-5.447,15.409,15.409,0,0,1,4.815,5.384q32.166,56.475,64.343,112.945a31.524,31.524,0,0,1,2.281,5.812Zm-80-116.37c-.324.546-.484.807-.637,1.074Q-697.264-148.062-729-92.334c-.892,1.566-.887,1.574.966,1.574q63.107,0,126.213,0c.313,0,.626,0,.938,0,.661.008.865-.246.513-.844-.184-.311-.346-.633-.526-.947q-28.41-49.879-56.825-99.755C-660.064-196.416-662.409-200.523-664.887-204.864Z",
    transform: "translate(0 0)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5105",
    "data-name": "Path 5105",
    d: "M-670.613-210.394c2.479,4.332,4.826,8.43,7.168,12.529q28.432,49.764,56.859,99.53c.18.313.342.635.526.945.352.6.148.85-.514.842-.313,0-.626,0-.939,0q-63.142,0-126.288,0c-1.854,0-1.859-.008-.966-1.57q31.756-55.6,63.516-111.2C-671.1-209.588-670.937-209.85-670.613-210.394Zm10.75,50.9a11.1,11.1,0,0,0-.693-3.789,10.737,10.737,0,0,0-12.758-6.526,10.842,10.842,0,0,0-7.845,11.966q1.928,12.789,3.948,25.566a6.563,6.563,0,0,0,6.537,5.87,6.905,6.905,0,0,0,6.643-5.847c.73-4.509,1.427-9.025,2.117-13.54C-661.218-150.354-660.545-154.922-659.863-159.489Zm-4.756,44.6a5.884,5.884,0,0,0-5.961-6,5.9,5.9,0,0,0-6.044,5.92,5.905,5.905,0,0,0,5.887,5.924A5.9,5.9,0,0,0-664.619-114.894Z",
    transform: "translate(5.726 5.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5106",
    "data-name": "Path 5106",
    d: "M-680.31-174.189c-.68,4.618-1.35,9.235-2.045,13.85-.688,4.565-1.382,9.13-2.11,13.688a6.916,6.916,0,0,1-6.622,5.91,6.576,6.576,0,0,1-6.517-5.934q-1.99-12.919-3.936-25.845a10.96,10.96,0,0,1,7.821-12.1,10.671,10.671,0,0,1,12.718,6.6A11.356,11.356,0,0,1-680.31-174.189Z",
    transform: "translate(26.14 20.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5107",
    "data-name": "Path 5107",
    d: "M-686.79-147.783a5.924,5.924,0,0,1-6.1,5.91,5.929,5.929,0,0,1-5.869-5.989,5.916,5.916,0,0,1,6.026-5.984A5.908,5.908,0,0,1-686.79-147.783Z",
    transform: "translate(27.879 38.605)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.97a36698ac445c62348b97564b2131f7.svg";
export { ForwardRef as ReactComponent };